import { Component, OnInit } from '@angular/core';
import { MachineStatus } from '../plate-status1/model/machine-status';
import { ErrorHandler } from '../utils/error-handler';
import { MessagesService } from '../messages/messages.service';
import { DatePipe } from '@angular/common';
import { MasterDataService } from '../masterdata/masterdata.service';
import { PlateStatusService } from '../plate-status1/plate-status.service';
import { SortEvent } from 'primeng/api';
import { Machine } from '../masterdata/models/machine';

@Component({
  selector: 'app-apg-machine-status',
  templateUrl: './apg-machine-status.component.html',
  styleUrls: ['./apg-machine-status.component.css']
})
export class ApgMachineStatusComponent implements OnInit {

  selectedLabId: string;
  errorHandler: ErrorHandler = new ErrorHandler();

  machinesList:MachineStatus[]=[];
  machineDetails: any = {};
  barcodeMachineListMapping: any = {};

  loading: boolean;
  dataRefresher: any;

  constructor(private plateStatusService: PlateStatusService, private masterDataService: MasterDataService,
    private _messagesService: MessagesService, public datepipe: DatePipe) { }

  ngOnInit() {
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.fetchMachines();
    this.refreshData();
  }
  refreshData(){
    this.dataRefresher =
      setInterval(() => {
        this.fetchMachines();
      }, 60000);
  }

  cancelPageRefresh(){
    if(this.dataRefresher){
        clearInterval(this.dataRefresher);
    }
  }

  ngOnDestroy(){
    this.cancelPageRefresh();
  }

  fetchMachines(){
    this.masterDataService.getConfigList(this.selectedLabId, "machine", 0, 100).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.machinesList = [];
        results.data.forEach((element) => {
          if(element.latestProcessStep != undefined &&  element.latestProcessStepTimeStamp != undefined){
            let stepRuntimeDetails = {};
            element.type.stepRuntimes.forEach((steps) =>{
              if(element.latestWorkFlow!=""){
                if(element.latestWorkFlow == steps.workflow)
                  stepRuntimeDetails[steps.step] = steps.runtime
              }
              else
                stepRuntimeDetails[steps.step] = steps.runtime
            });
            let machineStatus = new MachineStatus();
            machineStatus.machineName = element.name;
            machineStatus.machineType = element.type.name;
            machineStatus.processStep = element.latestProcessStep;
            machineStatus.startTimeStamp = element.latestProcessStepTimeStamp;
            machineStatus.processRunTime = stepRuntimeDetails[element.latestProcessStep];
            machineStatus.endTime = new Date(this.calculateEndTime(machineStatus.processRunTime, machineStatus.startTimeStamp).toString());
            machineStatus.remMin = this.calculateRemainingTime(machineStatus.endTime);
            this.machinesList.push(machineStatus);
          }
        });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  calculateRemainingTime(processEndTime: Date) {
    let remainingTime = processEndTime.getTime() - this.getNowUTC().getTime();
    if(remainingTime<=0){
      remainingTime=0;
    }
    return  Math.round(remainingTime / 60000);
  }

  private getNowUTC() {
    const now = new Date();
    return new Date(now.getTime());
  }

  calculateEndTime(processRunTime: number, processStartTime: any) {
    const date_: Date = new Date(processStartTime);
    date_.setMinutes(date_.getMinutes() + processRunTime);

    return date_;
  }

  getValue(machineValue: MachineStatus) {
    return 100 - Math.round((machineValue.remMin / machineValue.processRunTime) * 100);
  }

  isIndeterminate(machineValue: MachineStatus) {
    if (machineValue.startTimeStamp) {
      return 'determinate';
    } else {
      return machineValue.remMin == 0 ? 'indeterminate' : 'determinate';
    }
  }

  getActionStatus(machineValue: MachineStatus){
    if (machineValue.remMin == undefined)
      return 3
    if(machineValue.remMin == 0)
      return 1;
    else if(machineValue.remMin>0 && machineValue.remMin<=60)
      return 2;
    else
      return 3;
  }

  customSort(event: SortEvent) {

    event.data.sort((data1, data2) => {

      let value1,value2;
      
      if(event.field == 'remainingPercent'){
        value1 = this.getValue(data1);
        value2 = this.getValue(data2);
      }
      else{
        value1 = data1[event.field];
        value2 = data2[event.field];
      }
      let result = null;
      if (value1 == null && value2 != null)
        result = -1;
      else if (value1 != null && value2 == null)
        result = 1;
      else if (value1 == null && value2 == null)
        result = 0;
      else if (typeof value1 === 'string' && typeof value2 === 'string')
        result = value1.localeCompare(value2);
      else
        result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

      return (event.order * result);
    });
  }

  
}
